import React, { useEffect } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";

import LoginPage from "./features/auth/pages/LoginPage";
import LogoutPage from "./features/auth/pages/LogoutPage";
import HomePage from "./features/home/pages/HomePage";
import TestPage from "./features/home/pages/TestPage";
import ResultsPage from "./features/home/pages/ResultsPage";
import TestResultPage from "./features/home/pages/TestResultPage";

const ENABLE_EVENING_DARK_MODE =
  (process.env.REACT_APP_ENABLE_EVENING_DARK_MODE || "").toLowerCase() === "true";

const isEveningWindow = () => {
  const hour = new Date().getHours();
  return hour >= 18 || hour < 6;
};

function App() {
  useEffect(() => {
    if (!ENABLE_EVENING_DARK_MODE) {
      document.body.classList.remove("theme-dark");
      return undefined;
    }

    const syncTheme = () => {
      document.body.classList.toggle("theme-dark", isEveningWindow());
    };

    syncTheme();
    const timerId = window.setInterval(syncTheme, 60 * 1000);

    return () => {
      window.clearInterval(timerId);
      document.body.classList.remove("theme-dark");
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<HomePage />} />
        <Route path="/tests/:testId" element={<TestPage />} />
        <Route path="/results/:testId" element={<ResultsPage />} />
        <Route path="/test-review/:testId" element={<TestResultPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
